import { render } from "./WorkExperience.vue?vue&type=template&id=1920257d"
import script from "./WorkExperience.vue?vue&type=script&lang=js"
export * from "./WorkExperience.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__